import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", () => this.format())
    this.element.addEventListener("focus", () => this.format())
  }

  format() {
    let value = this.element.value.replace(/\D/g, "")

    if (value.length === 0) {
      this.element.value = ""
      return
    }

    if (value.startsWith("8")) {
      value = "8" + value.slice(1)
    } else if (value.startsWith("7")) {
      value = "+7" + value.slice(1)
    } else {
      value = "+7" + value
    }

    let formatted = "+7"
    const rest = value.slice(value.startsWith("+7") ? 2 : 1)

    if (rest.length > 0) formatted += " " + rest.slice(0, 3)
    if (rest.length > 3) formatted += " " + rest.slice(3, 6)
    if (rest.length > 6) formatted += " " + rest.slice(6, 8)
    if (rest.length > 8) formatted += " " + rest.slice(8, 10)

    this.element.value = formatted
  }
}
